module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('save-icon'), _vm._v(" "), (_vm.submitting) ? [_vm._v("Zapisuję...")] : [_vm._v("Zapisz")]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29af01d9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubmitButton.vue
// module id = 431
// module chunks = 1